// Entry point.
//
// Boot sequence:
//   1. Register / unregister service worker per build mode.
//   2. Initialise storage backend (IndexedDB).
//   3. Subscribe to session lock/unlock so the lock overlay shows/hides automatically.
//   4. Start the router — screens render behind the overlay (no flash) and become
//      interactive only after the first unlock.
//   5. Start auto-lock listener (visibilitychange-driven).
//   6. Show the lock screen — first-run setup or unlock, whichever applies.

import './style.css';
import { setBackend } from './storage/storage.js';
import { createIndexedDBBackend } from './storage/indexeddb-backend.js';
import { startRouter } from './ui/router.js';
import { on, startAutoLock } from './auth/session.js';
import { showLockScreen, hideLockScreen } from './ui/lock-screen.js';

if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('./sw.js')
        .catch((err) => console.warn('SW registration failed:', err));
    });
  } else {
    // In dev, ensure no stale prod SW is shadowing the Vite dev server.
    navigator.serviceWorker.getRegistrations().then((regs) =>
      regs.forEach((r) => r.unregister())
    );
  }
}

setBackend(createIndexedDBBackend());

on('unlock', () => hideLockScreen());
on('lock',   () => showLockScreen());

startRouter();
startAutoLock();

// Always start locked. The lock screen decides whether to render first-run or unlock.
showLockScreen();
